import ENV_PROD from './env.production';
import ENV_LOCAL from './env.local';

const ENV = __DEV__ ? ENV_LOCAL : ENV_PROD;

export default ENV;
